import { prefixObjectValues as pre } from '../../../utils';
const prefix = 'email-table';

const table = pre(
  {
    emailRow: 'table-row-',
    emailAddressRow: 'table-address-row-',
    isPrimaryRpw: 'table-primary-row-',
    addEmailBtn: 'add-btn',
  },
  prefix
);

export default table;
